// extracted by mini-css-extract-plugin
module.exports = {"header":"Current_header__2RH1a","deleteBtn":"Current_deleteBtn__qWFsI","selectAll":"Current_selectAll__18R-5","privateContainer":"Current_privateContainer__38Wr1"};